<template>
  <div v-if="show">
    <v-footer :color="details.backgroundColor" height="240" dark padless>
      <v-row
        justify="space-between"
        align="center"
        no-gutters
        class="mx-1"
        :class="[$vuetify.breakpoint.mdAndUp ? 'pdx-10' : 'px-5']"
      >
        <v-col
          cols="12"
          md="4"
          lg="4"
          xl="4"
          :class="$vuetify.breakpoint.smAndDown ? 'd-flex justify-center' : ''"
        >
          <!-- <router-link to="/shop/reseller/fourello">
            <v-img
              contain
              src="@/assets/images/reseller/logo.png"
              max-height="250"
              max-width="250"
            ></v-img>
          </router-link> -->

          <router-link to="/shop/reseller/fourello">
            <div
              class="display-2 white--text font-weight-black text--lighten-1"
            >
              <img
                :src="logo"
                width="175px"
                style="object-fit: contain"
              />
            </div>
          </router-link>
        </v-col>

        <v-col
          align-self="start"
          cols="12"
          md="4"
          lg="4"
          xl="4"
          :class="[$vuetify.breakpoint.smAndDown ? 'my-5 text-center' : '']"
        >
          <div v-for="(contact, key) in contacts" :key="key" class="d-flex">
            <div style="width:100px">
              {{ contact.label }}:
            </div>
            <div v-for="(numbers, numbersKey) in contact.numbers" :key="numbersKey" class="pl-4">
              {{ numbers }}
            </div>
          </div>
        </v-col>

        <v-col
          align-self="start"
          cols="12"
          md="4"
          lg="4"
          xl="4"
          :class="$vuetify.breakpoint.smAndDown ? 'text-center' : ''"
        >
          <div
            :class="[{ 'accent--text': condition_dialog }, 'mb-1 text-hover']"
            @click="condition_dialog = true"
          >
            Terms and Conditions
          </div>

          <div
            :class="[{ 'accent--text': policy_dialog }, 'mb-1 text-hover']"
            @click="policy_dialog = true"
          >
            Privacy Policy
          </div>
        </v-col>
      </v-row>
    </v-footer>

    <ConditionDialog
      v-model="condition_dialog"
      :items="termsAndConditions"
      :logo="logo"
    ></ConditionDialog>

    <PolicyDialog
      v-model="policy_dialog"
      :items="privacyPolicies"
      :logo="logo"
    ></PolicyDialog>
  </div>
</template>

<script>
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";
export default {
  name: "ResellerFooter",

  components: {
    ConditionDialog: () => import("./ConditionDialog.vue"),
    PolicyDialog: () => import("./PolicyDialog.vue"),
  },

  data: () => ({
    condition_dialog: false,
    policy_dialog: false,
    details: {},
    show: false
  }),

  props: {
    reseller: {
      type: Object,
      required: true,
    },
    termsAndConditions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    privacyPolicies: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  computed: {
    logo() {
      let reseller = this.reseller;

      if (reseller) {
        if(reseller.logo_image) {
          return reseller.logo_image.main || null;
        }
      }

      return null;
    },
    contacts() {
      let reseller = this.reseller;

      if (reseller) {
        if (reseller.contacts) {
          return JSON.parse(reseller.contacts) || [];
        }
      }

      return [];
    },
    resellerDetails: function() {
      console.log({RESELLER_EVENT_BUS})
        return RESELLER_EVENT_BUS.resellerDetails
          ? RESELLER_EVENT_BUS.resellerDetails.section
          : null;
      }
  },
  watch: {
    resellerDetails: {
      handler: function(value) {
        console.log({ value }, "footer")
        if (value) {
          this.details = value.footer;
          this.show = true;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>